module.exports = __webpack_public_path__ + "assets/img/boy@2x.68d3f9e2.png";